import { createFileRoute, Link } from '@tanstack/react-router';
import { CheckEditor } from '../../components/checks/CheckEditor';
import { useActiveCompanyId } from '../../stores/useCompanyStore';

export const Route = createFileRoute('/_auth/checks/new')({
  validateSearch: (search: Record<string, unknown>): { copyFrom?: string; payLine?: string } => ({
    copyFrom: typeof search.copyFrom === 'string' ? search.copyFrom : undefined,
    // An accrued paycheque (journal line id) this check should pay.
    payLine: typeof search.payLine === 'string' ? search.payLine : undefined,
  }),
  component: WriteCheckPage,
});

function WriteCheckPage() {
  const companyId = useActiveCompanyId();
  const { copyFrom, payLine } = Route.useSearch();

  if (!companyId) {
    return (
      <div className="card" style={{ textAlign: 'center', padding: 32 }}>
        <p className="muted">No active company.</p>
        <Link to="/companies" className="btn-primary" style={{ display: 'inline-block', textDecoration: 'none' }}>
          Go to Companies
        </Link>
      </div>
    );
  }

  return <CheckEditor companyId={companyId} copyFromId={copyFrom} payLineId={payLine} />;
}
